import { Box } from "@mui/material";
import ProfileHeader from "./components/ProfileHeader";
import ProfileAvatar from "./components/ProfileAvatar";
import ProfileTabs from "./components/ProfileTabs";

const ProfilePage = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        mt: { xs: 4, sm: 6 },
        maxWidth: 800,
        mx: "auto",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <ProfileHeader />
      <ProfileAvatar />
      <ProfileTabs />
    </Box>
  );
};

export default ProfilePage;
